import { observer } from "mobx-react-lite";
import React from "react";

import { BaseCheckbox } from "./base-checkbox";
import { FieldProps, useModelBinding } from "./utils";

interface Props<M extends object> extends FieldProps<M, boolean> {
  disabled?: boolean;
  label?: string;
  /** For checkboxes with no visible `label`, which would otherwise be unnamed. */
  ariaLabel?: string;
}

export const Checkbox = observer(function Checkbox<M extends object>({
  disabled,
  label,
  ariaLabel,
  ...restProps
}: Props<M>) {
  const { value, onChange } = useModelBinding(restProps);
  const checked = value ?? false;

  const checkbox = (
    <BaseCheckbox
      checked={checked}
      onCheckedChange={(newChecked) => {
        onChange(newChecked === true);
      }}
      disabled={disabled}
      aria-label={ariaLabel}
    />
  );

  if (label) {
    return (
      <label className="flex items-center gap-1">
        <span>{label}</span>
        {checkbox}
      </label>
    );
  }

  return checkbox;
});
